
import { FC } from 'react';
import { Container, Card, CardBody, Row, Col } from 'reactstrap';
import { EmbedYoutubeWrapper } from './EmbedYoutube.styled';

interface EmbedYoutubeProps {
   videoType: string;
   videoList: string[];
}

const EmbedYoutube: FC<EmbedYoutubeProps> = ({videoType, videoList}) => (
 <EmbedYoutubeWrapper>
   {videoType === 'video' &&
      <figure className="is-type-video is-provider-youtube">
         <iframe 
            className="responsive-iframe"
            loading="lazy" 
            width="1000" 
            height="500" 
            src={`https://www.youtube.com/embed/${videoList.at(0)}`}
            title="youtube video" 
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerPolicy="strict-origin-when-cross-origin" 
            allowFullScreen 
            data-no-lazy="1" 
            style={{ opacity: '1' }}
       ></iframe>
      </figure>
   }
   {videoType === 'playlist' &&  
      <Container  className="mt-4">
         <Row>
         {videoList.map((id:string) => (
            <Col md={4} className="mb-1">
               <Card key={id} className="h-100 shadow-sm">
                  <CardBody style={{padding: 'initial'}}>
                  <figure className="is-type-video is-provider-youtube">
                     <iframe 
                        className="responsive-iframe"
                        loading="lazy"  
                        src={`https://www.youtube.com/embed/${id}`}
                        title="youtube video" 
                        allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen 
                        data-no-lazy="1" 
                        style={{marginTop: '0.6rem'}}
                   ></iframe>
                  </figure>
                  </CardBody>
               </Card>
            </Col>
         ))}
         </Row>
      </Container>
   }
 </EmbedYoutubeWrapper>
);

export default EmbedYoutube;
